import { render, staticRenderFns } from "./ItemInquiry.vue?vue&type=template&id=d7c3913a"
import script from "./ItemInquiry.vue?vue&type=script&lang=js"
export * from "./ItemInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports